import { useEffect } from 'react';

import { useDispatch, useSelector } from 'react-redux';
import { cachedSetEnergyKwickKpiDataMemberRanking } from '@flexo/reducers';
import { useLocation, useParams } from 'react-router-dom';

export const EnergyKwickMemberRankingResolver = () => {

  const dispatch = useDispatch();
  const location = useLocation();
  const params = useParams();
  const metadata = useSelector((state: any) => state.metadata);
  const calendar = useSelector((state: any) => state.calendar);
  const pathSegment = location.pathname.split('/')[1]; 

  const { hiveCalendar } = calendar;
  const { selectedDate, selectedTimeSet } = hiveCalendar;

  async function init() {

    if (!location.pathname.includes('member')) { return; }

    const MEMBER_ID = params?.id || metadata?.selectedEntity?.memberId || null;

    if (!MEMBER_ID) { return; }

    // Token auto-injected by httpService interceptor
    dispatch(cachedSetEnergyKwickKpiDataMemberRanking({MEMBER_ID, selectedDate, selectedTimeSet}) as any);
  }

  useEffect(() => {
      init();
  }, []);

  useEffect(() => {
      init();
  }, [selectedDate, params?.id, pathSegment]);

  return <></>;
};
